import { Mail } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { useSettings } from "@/context/AppSettings";
import { LegalComplianceModal } from "@/components/v2/LegalComplianceModal";

export const Footer = () => {
  const { lang, t } = useLang();
  const isRu = lang === "ru";
  const settings = useSettings();
  const email = settings.email || "info@melnikbrokers.ae";
  const brand = settings.company_name || "MELNIK Commercial Brokers";
  const licenceLabel = isRu ? "Лицензированный коммерческий брокер · Лицензия №" : "Licensed commercial broker · Licence No.";

  return (
    <footer data-testid="footer" className="border-t border-white/8 py-14">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <div className="flex flex-wrap items-start justify-between gap-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-3" aria-label={brand}><img src="/melnik-monogram.png" alt="" className="h-14 w-auto object-contain" /><span className="flex flex-col leading-none"><span className="font-serif text-xl tracking-[0.13em] text-[#F5F0E4]">MELNIK</span><span className="mt-1.5 text-[0.52rem] font-semibold tracking-[0.28em] text-[#D4AF37]">COMMERCIAL BROKERS</span></span></span>
            </div>
            <p className="mt-4 max-w-sm text-xs leading-relaxed text-slate-500 sm:text-sm">{t("footer.tagline")}</p>
          </div>
          <nav aria-label={isRu ? "Коммерческая информация" : "Commercial information"} className="min-w-[12rem]">
            <div className="text-xs uppercase tracking-[0.25em] text-slate-500">{isRu ? "Коммерческая информация" : "Commercial information"}</div>
            <div className="mt-3 grid gap-2 text-sm">
              <a href="/" className="text-slate-400 transition-colors hover:text-[#F3E5AB]">{isRu ? "B2B-коммерческие знакомства" : "B2B commercial introductions"}</a>
              <a href="/gold-brokerage-dubai" className="text-slate-400 transition-colors hover:text-[#F3E5AB]">{isRu ? "Золотое брокерство в Дубае" : "Gold brokerage in Dubai"}</a>
              <a href="/sblc-escrow-gold-brokerage-dubai" className="text-slate-400 transition-colors hover:text-[#F3E5AB]">{isRu ? "Координация SBLC и escrow" : "SBLC & escrow coordination"}</a>
              <a href="/petroleum-brokerage-dubai" className="text-slate-400 transition-colors hover:text-[#F3E5AB]">{isRu ? "Нефтяное брокерство" : "Petroleum brokerage"}</a>
              <a href="/gold-petroleum-transaction-process" className="text-slate-400 transition-colors hover:text-[#F3E5AB]">{isRu ? "Процесс коммерческого знакомства" : "Commercial introduction process"}</a>
              <a href="/kyc-aml-commercial-brokerage" className="text-slate-400 transition-colors hover:text-[#F3E5AB]">{isRu ? "Подготовка KYC, KYB и AML" : "KYC, KYB & AML preparation"}</a>
              <a href="/privacy-policy" data-testid="footer-privacy-policy-link" className="text-slate-400 transition-colors hover:text-[#F3E5AB]">{isRu ? "Политика конфиденциальности" : "Privacy Policy"}</a>
            </div>
          </nav>
          <div className="sm:text-right">
            <div className="text-xs uppercase tracking-[0.25em] text-slate-500">{t("contact.overline")}</div>
            <a
              href={`mailto:${email}`}
              data-testid="footer-email-link"
              className="mt-2 inline-flex items-center gap-2.5 text-lg text-[#F3E5AB] transition-colors hover:text-[#D4AF37]"
            >
              <Mail className="h-4 w-4" />
              {email}
            </a>
            <div>
              <LegalComplianceModal />
            </div>
          </div>
        </div>
        <div className="mt-12 flex flex-wrap items-center justify-between gap-4 border-t border-white/5 pt-8">
          <p className="max-w-2xl text-xs leading-relaxed text-slate-600">{t("footer.disclaimer")} {settings.license_number ? `${licenceLabel} ${settings.license_number}.` : ""}</p>
        </div>
      </div>
    </footer>
  );
};
